var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 956,
    height: 897,
    viewBox: "0 0 956 897",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1297 -6.5C1297 209.867 934.058 381.654 480 384.953C475.674 384.984 468.841 395 464.5 395C460.159 395 455.653 384.973 450 384.919C-2.20563 380.621 -369 209.232 -369 -6.5C-369 -224.929 3.94681 -402 464 -402C924.053 -402 1297 -224.929 1297 -6.5Z",
    fill: "url(#paint0_linear_9447_79336)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1332 -14.5C1332 202.004 944.819 377.877 476.996 380.959C472.838 380.986 467.5 390 464.5 390C461.5 390 456.16 380.986 452 380.959C-15.8213 377.876 -383 202.004 -383 -14.5C-383 -232.929 0.915833 -400 474.5 -400C948.084 -400 1332 -232.929 1332 -14.5Z",
    fill: "url(#paint1_linear_9447_79336)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9447_79336",
    x1: -103.514,
    y1: 287,
    x2: 1087.47,
    y2: 301.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDDAA",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480576,
    stopColor: "#FEE4C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE1BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9447_79336",
    x1: 96.5,
    y1: -182.5,
    x2: 988,
    y2: 421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23253E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26263E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProBg);
export default __webpack_public_path__ + "static/media/pro-bg.1987c2998943ab5afe8559202c926056.svg";
export { ForwardRef as ReactComponent };